import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import RangeSliderBorderRadius from "../../../UI/RangeSliderBorderRadius";
import {
  AlignHorizontalJustifyStart,
  AlignHorizontalJustifyEnd,
  AlignVerticalJustifyStart,
  AlignVerticalJustifyEnd,
  AlignHorizontalSpaceBetween,
  AlignHorizontalSpaceAround,
 
  AlignHorizontalJustifyCenter,
  AlignHorizontalDistributeCenter,
  AlignVerticalJustifyCenter,
  AlignVerticalDistributeCenter,
  AlignVerticalSpaceBetween,
} from "lucide-react";
import {
  AlignVerticalSpaceAround,
  AlignVerticalJustifyStretch,
} from "lucide-react";
const ItemSelectBoxesSmallUI =  ({ itemsArray, callbackItemValue, objectValue,objectName,displayName ,}) => {
  const [items ,setItems] =useState(itemsArray);

 const flexDirectionIcons = {
  "row": <AlignHorizontalJustifyStart size={20} color="#666" />,
  "row-reverse": <AlignHorizontalJustifyEnd size={20} color="#666" />,
  "column": <AlignVerticalJustifyStart size={20} color="#666" />,
  "column-reverse": <AlignVerticalJustifyEnd size={20} color="#666" />
};
const justifyContentIcons = {
  "flex-start": <AlignHorizontalJustifyStart size={20} color="#666" />,
  "flex-end": <AlignHorizontalJustifyEnd size={20} color="#666" />,
  "center": <AlignHorizontalJustifyCenter size={20} color="#666" />,
  "space-between": <AlignHorizontalSpaceBetween size={20} color="#666" />,
  "space-around": <AlignHorizontalSpaceAround size={20} color="#666" />,
  "space-evenly": <AlignHorizontalDistributeCenter size={20} color="#666" />
};
const alignItemsIcons = {
  "flex-start": <AlignVerticalJustifyStart size={20} color="#666" />,
  "flex-end": <AlignVerticalJustifyEnd size={20} color="#666" />,
  "center": <AlignVerticalJustifyCenter size={20} color="#666" />,
  "stretch": <AlignVerticalSpaceBetween size={20} color="#666" />,  // use AlignVerticalJustifyStretch if available
  "baseline": <AlignVerticalDistributeCenter size={20} color="#666" /> // fallback to a generic if this isn't available
};
const alignContentIcons = {
  "flex-start": <AlignVerticalJustifyStart size={20} color="#666" />,
  "flex-end": <AlignVerticalJustifyEnd size={20} color="#666" />,
  "center": <AlignVerticalJustifyCenter size={20} color="#666" />,
  "stretch": <AlignVerticalSpaceBetween size={20} color="#666" />,
  "space-between": <AlignVerticalDistributeCenter size={20} color="#666" />,
  "space-around": <AlignVerticalSpaceAround size={20} color="#666" />
};
     const dispatch = useDispatch();  
     const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
            {
              
              dispatch({type: "CURSOR",payload:true  });
          
              dispatch({type: "CURSORTEXT",payload:CursorText})
              dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
              dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
            }
             
            const handleMouseLeave = () => {
              
              dispatch({type: "CURSOR",payload:false})
          
              dispatch({type: "CURSORTEXT",payload:""})
          
              dispatch({type: "CURSORTEXTBG",payload:""})
              dispatch({type: "CURSORTEXTCOLOR",payload:""})
            
          
          }
 const [itemValue, setItemValue] = useState(objectValue);

 return(<>


                                    <div  style={{display:"flex",justifyContent:"space-around"}}>
                                               <h4>{displayName} </h4>
           <div > 
            <div class="input-card-outer"style={{
                 
                  transition: 'transform 3s ease, opacity 3s ease',
                borderRadius:"25px",padding:"0px"}} >
                                          
                                          <div  style={{display:"flex",justifyContent:"left"}}>
                                                {items?.map((item,index)=>(
                                                 <> {index<4? <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333",item)}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                             <div style={{display:"flex",justifyContent:"space-between"}} >
                                              
                                               {
                                              objectName=="flexDirection"?flexDirectionIcons[item]:
                                              objectName=="justifyContent"?justifyContentIcons[item] :
                                              objectName=="alignItems"?alignItemsIcons[item]:
                                              objectName=="alignContent"?alignContentIcons[item]:
                                              item
                                              }
                                                                      </div>  
                              <input type="radio" title="Set As Years"   checked={
                                itemValue==item?"yes":""
                            }
                   className="input-textbox"  value={item}  name={objectName+"1"}  
                   onClick={e=>{
             
                callbackItemValue(item);
                   setItemValue(item);
                   }}/>
                        <span class={"boxCardBorder-two"}></span> </label>:""}
                                               </> ))} 
                        </div>
                              <div  style={{display:"flex",justifyContent:"left"}}>
                                                {items?.map((item,index)=>(
                                                 <> {index>=4? <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333",item)}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                             <div style={{display:"flex",justifyContent:"space-between"}} >
                                              
                                              {
                                              objectName=="flexDirection"?flexDirectionIcons[item]:
                                              objectName=="justifyContent"?justifyContentIcons[item] :
                                              objectName=="alignItems"?alignItemsIcons[item]:
                                              objectName=="alignContent"?alignContentIcons[item]:
                                              item
                                              }
                                            
                                                                      </div>  
                              <input type="radio" title="Set As Years"   checked={
                                itemValue==item?"yes":""
                            }
                   className="input-textbox"  value={item}  name={objectName+"1"}  
                   onClick={e=>{
             
                callbackItemValue(item);
                   setItemValue(item);
                   }}/>
                        <span class={"boxCardBorder-two"}></span> </label>:""}
                                               </> ))} 
                        </div>
                          </div>
                       
                        </div> </div>
                                 </>)

    } 
    export default ItemSelectBoxesSmallUI;

                     